module.exports = __webpack_public_path__ + "img/2.ce1c1569.png";